import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Card, CardContent } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Badge } from '../components/ui/badge';
import { MagnifyingGlass, EnvelopeSimple, Phone, MapPin, UsersThree } from '@phosphor-icons/react';
import { getCoopDirectory } from '../services/api';

export function PortalDirectoryPage() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState('');
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    const t = setTimeout(() => {
      getCoopDirectory(q).then((r) => setItems(r.data.items || [])).catch(() => toast.error('Erreur')).finally(() => setLoading(false));
    }, 250);
    return () => clearTimeout(t);
  }, [q]);
  return (
    <div className="space-y-4 p-6" data-testid="coop-directory-page">
      <div>
        <h1 className="text-2xl font-bold text-[#1A2421] flex items-center gap-2"><UsersThree size={22} /> Annuaire coopérateur·rices</h1>
        <p className="text-xs text-[#5E6D66]">Les membres de votre territoire et collège. Contactez-les librement pour vos projets communs.</p>
      </div>
      <div className="relative max-w-md">
        <MagnifyingGlass size={16} className="absolute left-2 top-2.5 text-[#5E6D66]"/>
        <Input value={q} onChange={(e)=>setQ(e.target.value)} placeholder="Rechercher un nom, email, territoire…" className="pl-8" data-testid="coop-search"/>
      </div>
      {loading && <p className="text-xs text-[#5E6D66]">Recherche…</p>}
      {!loading && items.length === 0 && <p className="text-xs text-[#5E6D66]">Aucun coopérateur trouvé.</p>}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {items.map((u) => (
          <Card key={u.id} className="border-[#E8E6E1]" data-testid={`coop-card-${u.id}`}>
            <CardContent className="p-4 space-y-1">
              <div className="flex items-center gap-2">
                <div className="w-9 h-9 rounded-full bg-[#2D5A4C] text-white flex items-center justify-center text-sm font-semibold">
                  {(u.prenom?.[0] || u.email[0]).toUpperCase()}
                </div>
                <div className="flex-1">
                  <p className="text-sm font-semibold">{u.prenom} {u.nom || u.email}</p>
                  {u.associate_number && <p className="text-[10px] text-[#5E6D66]">{u.associate_number}</p>}
                </div>
                <Badge className="bg-[#E8E6E1] text-[#1A2421] text-[10px]">{u.role === 'partenaire' ? 'Partenaire' : 'Coopérateur'}</Badge>
              </div>
              {u.email && <p className="text-xs flex items-center gap-1"><EnvelopeSimple size={12}/> <a href={`mailto:${u.email}`} className="text-[#2D5A4C] underline">{u.email}</a></p>}
              {u.phone && <p className="text-xs flex items-center gap-1"><Phone size={12}/> {u.phone}</p>}
              {(u.territoire || u.college) && (
                <p className="text-xs flex items-center gap-1 text-[#5E6D66]"><MapPin size={12}/> {u.territoire || '—'} · Collège {u.college || '—'}</p>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}

export default PortalDirectoryPage;
